//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('createPoPu', {
//        templateUrl: 'views/components/views/createPoPu/createPoPu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'createPoPuService', 'stateService', function ($stateParams, createPoPuService, stateService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let stockKeyno = $stateParams.stock_keyno;

//            vm.model = {
//                productIdButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.prod_id }) }
//                ],
//                edit: {},
//                lockedCreate: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await createPoPuService.getEdit({ stock_keyno: stockKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.createChanges = function () {
//                vm.model.lockedCreate = true;

//                createPoPuService.createObj(vm.model.edit).then(() => {
//                    vm.model.lockedCreate = false;
//                    stateService.back();
//                }, () => vm.model.lockedCreate = false);
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
